import { create } from 'zustand'

export type NoteContentType = 'MDX' | 'TXT';

export type Note = {
  id: string | null;
  title?: string;
  content: string;
  content_type?: NoteContentType;
  content_status?: 'draft' | 'final';
  content_id?: number;
  seq?: number;
  color?: string;
  pinned?: boolean;
  date?: string;
  encrypted?: boolean;
  body_locked?: boolean;
  body_error?: string;
  has_history?: boolean;
  has_key_wrapper?: boolean;
  content_updated_at?: string; // ISO — updated_at of the current note revision
  user_name?: string;
  tags?: string[];
  /** Transient — number of old versions pruned on last save. Not persisted in store. */
  versions_pruned?: number;
};

type NotesState = {
  notes: Note[]
}

type NotesAction = {
  setNotes: (payload: Note[]) => void
  addNote: (payload: Note) => void
  updateNote: (id: string | null, payload: Partial<Note>) => void
  deleteNote: (id: string | null) => void
  createNote: () => Note
}

const initialState: NotesState = {
  notes: [],
}

export const useNotesStore = create<NotesState & NotesAction>()((set, get) => ({
  ...initialState,
  setNotes: (payload) =>
    set(() => ({
      notes: payload,
    })),
  addNote: (payload) =>
    set((state) => ({
      notes: [payload, ...state.notes],
    })),
  updateNote: (id, payload) => {
    return set((state) => ({
      notes: state.notes.map((note) =>
        note.id === id ? {...note, ...payload} : note
      ),
    }));
  },
  deleteNote: (id) =>
    set((state) => ({
      notes: state.notes.filter((note) => note.id !== id),
    })),
  createNote: () => {
    const newNote: Note = {
      id: null,
      title: '',
      content: '',
      content_type: 'MDX',
      date: new Date().toISOString().slice(0, 10),
    }
    set((state) => ({
      notes: [newNote, ...state.notes],
    }))

    // Navigate to the note page (will be created via API)
    // For now, we'll create it first then navigate
    return newNote
  },
}))
